import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import HowDeliverooWorks from '../../components/HowDeliverooWorks';

export function HowDeliverooWorksContainer({ isUserLoggedIn }) {
  if (isUserLoggedIn) return null;

  return (
    <PageContainer fullWidth="always">
      <HowDeliverooWorks />
    </PageContainer>
  );
}

HowDeliverooWorksContainer.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
};

export default connect((state) => ({
  isUserLoggedIn: state.user.isLoggedIn,
}))(HowDeliverooWorksContainer);
